SupportV1USViewManagerHelper = require('./US/v1')
SupportV1INTLViewManagerHelper = require('./INTL/v1')
SupportV2USViewManagerHelper = require('./US/v2')
SupportVerticalHelpWizardViewManagerHelper = require('./vertical_view_manager')

SupportViewManagerFactoryView =

  getViewManager: () ->
    if window.isUS()
      if Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled()
        new SupportV2USViewManagerHelper
      else
        new SupportV1USViewManagerHelper
    else
      if window.evaluate(window.experiments?.showVerticalPageFlow)
        new SupportVerticalHelpWizardViewManagerHelper
      else
        new SupportV1INTLViewManagerHelper

module.exports = SupportViewManagerFactoryView
